import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/capsule.svg` */
export const CapsuleSolidIcon = createTripletGlyphIcon('CapsuleSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5835 3.8429C9.63855 2.87731 11.2433 2.95971 12.1938 4.03528C13.1604 5.12902 13.0821 6.83214 12.019 7.83215L10.104 9.63293L10.103 9.63196L9.74951 9.96497L7.45361 12.1251L7.34326 12.2238C6.28946 13.1184 4.73426 13.0158 3.80518 11.965C2.83889 10.8712 2.91724 9.16797 3.97998 8.16809L8.51807 3.90149C8.53428 3.88625 8.54127 3.88099 8.57764 3.84875L8.5835 3.8429ZM6.32861 6.09387L4.02295 8.26379C3.00933 9.21765 2.93438 10.8309 3.85596 11.8741C4.78592 12.9264 6.37679 12.9997 7.3999 12.0382V12.0372L9.70557 9.86731L10.0581 9.53528L9.73779 9.17297L7.04639 6.12708L6.70459 5.74036L6.32861 6.09387Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.999995"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.65454 4.32385C10.8413 3.23646 12.6481 3.32915 13.718 4.53967C14.8054 5.77025 14.717 7.68621 13.5208 8.81116L11.5198 10.693L11.5188 10.691L11.3899 10.8121L11.0461 10.4225L7.83618 6.78967L7.46899 6.37561L9.58228 4.38831C9.60054 4.37114 9.60509 4.36751 9.64771 4.32971L9.65454 4.32385Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.12499"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9299 5.76086C14.5124 4.3108 16.9224 4.43409 18.3489 6.04797V6.047C19.7534 7.63629 19.6862 10.0845 18.2307 11.5997L18.0852 11.7433L15.2463 14.4132L14.8967 14.0177L10.3958 8.92493L10.0159 8.49524L12.8342 5.84583C12.8573 5.82418 12.8753 5.8094 12.9211 5.76868L12.9299 5.76086Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  ),
});
